module.exports = __webpack_public_path__ + "static/media/21.777789a5.mp3";